import Settings from 'configs/Settings';

import Request from '@hotmart/request';

Request.register(`${Settings.api.content}/v1/content/dripping/bulk`, {
  post: {
    'dripping.bulk.by.days': '/release/by-days',
    'dripping.bulk.by.date': '/release/by-date',
    'dripping.bulk.expiration': '/expiration'
  },
  delete: {
    'delete.dripping.release': '/release',
    'delete.dripping.expiration': '/expiration'
  }
});
